﻿import { tns } from 'tiny-slider/src/tiny-slider';

document.addEventListener('DOMContentLoaded', function (event) {

    const homeSlider = document.querySelector('#home-custom-slider');
    if (homeSlider) {
        let slider = tns({
            container: homeSlider,
            mode: 'gallery',
            items: 1,
            loop: true,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayPosition: 'bottom',
            controls: true,
            controlsPosition: 'bottom',
            controlsContainer: '#home-custom-slider-buttons',
            nav: false,
            navPosition: 'bottom',
            navAsThumbnails: true,
            animateIn: 'animate__fadeIn',
            animateOut: 'animate__fadeOut'
        });
        let info = slider.getInfo();
        toggleClasses(info.slideItems[info.index]);

        slider.events.on('indexChanged', function (info, eventName) {
            let indexPrev = info.indexCached;
            let indexCurrent = info.index;

            let prevSlide = info.slideItems[indexPrev];
            toggleClasses(prevSlide);
            let currentSlide = info.slideItems[indexCurrent]
            toggleClasses(currentSlide);
        });
    }

    function toggleClasses(slide) {
        let animatedElements = slide.querySelectorAll('[data-animate]')
        animatedElements.forEach((element) => {
            if (element.dataset.animate) {
                element.classList.toggle(element.dataset.animate);
            }
        });
    }

    const productCarousel = document.querySelector('#images-custom-carousel');
    if (productCarousel) {
        const productCarouselControls = document.querySelector('#images-carousel-controls');
        
        let slider = tns({
            container: productCarousel,
            mode: 'gallery',
            controls: true,
            controlsPosition: 'bottom',
            controlsContainer: '#images-custom-carousel-buttons',
            nav: productCarouselControls !== undefined,
            navContainer: productCarouselControls,
            navAsThumbnails: true,
            speed: 1000,
            autoplay: false,
            autoplayButtonOutput: false,
            items: 1,
            slideBy: 'page',
            mouseDrag: true,
            autoHeight: false
        });        
    }
});